// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {filterSearchResults} from '../../shared/services/claim-search-helper';
import moment from 'moment';

export const resetAllFacets = (facets, claimSettings) =>
    (dispatch, getState) => {

        const defaultSearchResults = getState().claims.claimSearch.searchResults;

        dispatch({
            claimDateRange: {
                from: moment.utc().subtract(claimSettings.numberOfDays, 'days').startOf('day')
                    .valueOf(),
                to: moment.utc().endOf('day').valueOf()
            },
            claimStatus: facets.claimStatusFacet.allowedStatus,
            claimTypes: facets.claimTypesFacet.allowedTypes,
            dateType: facets.dateTypeFacet.key,
            dealerAccounts: facets.dealerAccountsFacet.allowedDealers,
            type: actions.RESET_CLAIM_SEARCH_FILTERS
        });

        dispatch({
            data: defaultSearchResults,
            type: actions.FILTER_CLAIM_SEARCH_RESULTS
        });

    };

export const selectAllDealersOnInitialLoad = allowedDealers =>
    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.SELECT_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS
        });

        dispatch({
            allowedDealers,
            type: actions.SELECT_ALL_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEMS
        });

    };

export const updateDateRangeFacet = dateRange => ({
    dateRange,
    type: actions.UPDATE_CLAIM_DATE_RANGE_FACET
});

export const updateDateType = dateType => ({
    dateType,
    type: actions.UPDATE_CLAIM_DATE_TYPE
});

export const selectAllClaimStatusOnInitialLoad = allowedStatus => ({
    allowedStatus,
    type: actions.SELECT_ALL_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEMS
});

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEMS
});

export const toggleClaimTypeFacetItems = allowedTypes => ({
    allowedTypes,
    type: actions.TOGGLE_CLAIM_SEARCH_CLAIM_TYPE_FACET_ITEMS
});

export const toggleClaimStatusFacetItems = allowedStatus => ({
    allowedStatus,
    type: actions.TOGGLE_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEMS
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_INPUT,
    value
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_CLAIM_SEARCH_DEALER_ACCOUNT_FACET_ITEM
});

export const updateClaimTypeFacetItem = (claimType, isSelected) => ({
    claimType,
    isSelected,
    type: actions.UPDATE_CLAIM_SEARCH_CLAIM_TYPE_FACET_ITEM
});

export const updateClaimStatusFacetItem = (claimStatus, isSelected) => ({
    claimStatus,
    isSelected,
    type: actions.UPDATE_CLAIM_SEARCH_CLAIM_STATUS_FACET_ITEM
});

export const applySearchFilters = () =>
    (dispatch, getState) => {

        const {claimSearch} = getState().claims;
        const filterParams = {

            dateFilter: {
                selectedDateRange: claimSearch.facets.claimDateRangeFacet.dateRange,
                selectedDateType: claimSearch.facets.dateTypeFacet.key
            },
            selectedClaimStatus: claimSearch.facets.claimStatusFacet.selectedClaimStatus,
            selectedClaimTypes: claimSearch.facets.claimTypesFacet.selectedClaimTypes,
            selectedDealers: claimSearch.facets.dealerAccountsFacet.selectedDealers

        };

        const currentSearchResults = claimSearch.searchResults;

        dispatch({
            data: filterSearchResults(currentSearchResults, filterParams),
            type: actions.FILTER_CLAIM_SEARCH_RESULTS
        });

    };



// WEBPACK FOOTER //
// ./src/claim/claim-search/action-creators/facets.js